export const ON_CHANGE_DEBOUNCE_TIMER = 300;

export const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

export const product_json = JSON.parse(document.querySelector('.js-product-json')?.innerHTML || '{}');

// Nosto
(function () {
  var name = 'nostojs';
  window[name] =
    window[name] ||
    function (cb) {
      (window[name].q = window[name].q || []).push(cb);
    };
})();

// Custom Nosto integration
if (window.location.href.includes('nosto=')) {
  // Nosto JS API record attribution before changing URL
  let nosto_url_param = window.location.search.slice(window.location.search.indexOf('nosto=') + 6);
  window.nostojs(function (api) {
    api.defaultSession().recordAttribution('vp', `${product_json.id}`, `${nosto_url_param}`).done();
  });
}

// Export the nostojs function for modular usage
export const nostojs = window.nostojs;

/**
 * Get product title for accessibility announcements
 * @returns {string} Product title
 */
export function getProductTitle() {
  const root = this.closest('.js-product-main') || this;
  const titleSelectors = [
    '.product__title',
    '.product-title',
    'h1',
    '[data-product-title]'
  ];
  
  for (const selector of titleSelectors) {
    const titleElement = root.querySelector(selector);
    if (titleElement && titleElement.textContent && titleElement.textContent.trim()) {
      return titleElement.textContent.trim();
    }
  }
  
  return 'Product';
}

/**
 * Get variant title for accessibility announcements
 * @param {string} variantId - The variant ID
 * @returns {string} Variant title or empty string
 */
export function getVariantTitle(variantId) {
  const root = this.closest('.js-product-main') || this;
  
  // 1) Try exact match by variant id (from radios/selects)
  if (variantId) {
    const byId =
      root.querySelector(`input[name="id"][value="${variantId}"]`) ||
      root.querySelector(`option[value="${variantId}"]`);
    if (byId) {
      const t = byId.dataset?.variantTitle ||
                byId.getAttribute?.('data-variant-title') ||
                (byId.tagName === 'OPTION' ? byId.textContent : '') ||
                (byId.nextElementSibling ? byId.nextElementSibling.textContent : '');
      if (t && t.trim()) return t.trim();
    }
  }
  
  // 2) Fallback to currently selected controls
  const variantSelectors = [
    'variant-radios input:checked',
    'variant-selects select option:checked',
    '[name="id"]:checked'
  ];
  for (const selector of variantSelectors) {
    const el = root.querySelector(selector);
    if (el) {
      const t = el.dataset?.variantTitle ||
                el.getAttribute?.('data-variant-title') ||
                (el.tagName === 'OPTION' ? el.textContent : '') ||
                (el.nextElementSibling ? el.nextElementSibling.textContent : '');
      if (t && t.trim()) return t.trim();
    }
  }
  
  // 3) Fallback to product JSON if available
  if (variantId && typeof product_json !== 'undefined' && product_json.variants) {
    const variant = product_json.variants.find(v => v.id.toString() === variantId.toString());
    if (variant && variant.title && variant.title.trim()) {
      return variant.title.trim();
    }
  }
  
  return '';
}

export function headerHeight() {
  const header = document.querySelector('.js-header');

  if (!header) return;

  const headerChildren = header.children;
  const announcementHeight = headerChildren.length > 0 ? headerChildren[0].clientHeight : 0;

  let height = 80;
  if (header && header.clientHeight > 0) {
    height = header.clientHeight;
  }

  document.documentElement.style.setProperty('--header-height', height + 'px');
  document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');

  return height;
}

headerHeight();
